export default __webpack_public_path__ + "static/media/appstore.4f4beccb.png";